export const vps = {
  title: 'VPS Hosting',
  subtitle: 'High-performance VPS servers with guaranteed resources',
  locations: {
    germanyGame: 'Germany (Gaming)',
    germanyPerf: 'Germany (Super Performance)',
    gameDescription: 'AMD Ryzen™ 9 5950X · Optimized for gaming with balanced performance',
    perfDescription: 'AMD Ryzen™ 9 7950X3D · Coming soon'
  },
  features: {
    hardware: {
      title: 'Dedicated Resources',
      description: 'Guaranteed CPU and RAM resources'
    },
    protection: {
      title: 'DDoS Protection',
      description: 'Advanced protection up to 4 Tbps'
    },
    storage: {
      title: 'NVMe Storage',
      description: 'Ultra-fast SSD storage'
    }
  },
  comingSoon: {
    title: 'Coming Soon',
    description:
      'The “Super Performance” line with AMD Ryzen™ 9 7950X3D CPUs will be available soon. We are working to deliver top-tier performance.'
  },
  latencyTest: {
    title: 'Network Latency Test',
    startTest: 'Start Test',
    testing: 'Testing...',
    timeout: 'Timeout',
    average: 'Average Latency'
  },
  plans: {
    title: 'Available Plans',
    de: {
      game: [
        {
          title: 'Standard Game VPS Nano',
          price: '€2.70',
          specs: [
            '1 vCore',
            '1GB RAM',
            '20GB NVMe',
            'Unlimited Traffic',
            'DDoS Protection',
            'Optimized for Gaming'
          ]
        },
        {
          title: 'Standard Game VPS Micro',
          price: '€5.40',
          specs: [
            '1 vCore',
            '2GB RAM',
            '20GB NVMe',
            'Unlimited Traffic',
            'DDoS Protection',
            'Optimized for Gaming'
          ]
        },
        {
          title: 'Standard Game VPS Lite',
          price: '€7.20',
          specs: [
            '2 vCore',
            '4GB RAM',
            '40GB NVMe',
            'Unlimited Traffic',
            'DDoS Protection',
            'Optimized for Gaming'
          ]
        },
        {
          title: 'Standard Game VPS Boost',
          price: '€9.00',
          specs: [
            '2 vCore',
            '6GB RAM',
            '60GB NVMe',
            'Unlimited Traffic',
            'DDoS Protection',
            'Optimized for Gaming'
          ]
        },
        {
          title: 'Standard Game VPS Turbo',
          price: '€10.80',
          specs: [
            '4 vCore',
            '8GB RAM',
            '80GB NVMe',
            'Unlimited Traffic',
            'DDoS Protection',
            'Optimized for Gaming'
          ]
        },
        {
          title: 'Standard Game VPS Power',
          price: '€14.40',
          specs: [
            '4 vCore',
            '12GB RAM',
            '100GB NVMe',
            'Unlimited Traffic',
            'DDoS Protection',
            'Optimized for Gaming'
          ]
        },
        {
          title: 'Standard Game VPS Pro',
          price: '€21.60',
          specs: [
            '6 vCore',
            '16GB RAM',
            '120GB NVMe',
            'Unlimited Traffic',
            'DDoS Protection',
            'Optimized for Gaming'
          ]
        },
        {
          title: 'Standard Game VPS Max',
          price: '€28.80',
          specs: [
            '6 vCore',
            '24GB RAM',
            '140GB NVMe',
            'Unlimited Traffic',
            'DDoS Protection',
            'Optimized for Gaming'
          ]
        },
        {
          title: 'Standard Game VPS Ultra',
          price: '€37.80',
          specs: [
            '6 vCore',
            '32GB RAM',
            '160GB NVMe',
            'Unlimited Traffic',
            'DDoS Protection',
            'Optimized for Gaming'
          ]
        },
        {
          title: 'Standard Game VPS Hyper',
          price: '€57.60',
          specs: [
            '8 vCore',
            '48GB RAM',
            '200GB NVMe',
            'Unlimited Traffic',
            'DDoS Protection',
            'Optimized for Gaming'
          ]
        }
      ],
      performance: [
        {
          title: 'Super Performance VPS Nano',
          price: '€3.99',
          specs: [
            '1 vCore (AMD Ryzen™ 9 7950X3D)',
            '1GB RAM',
            '10GB NVMe',
            'Uplink: 100 Mbps',
            'DDoS Protection',
            'High-Performance CPU'
          ]
        },
        {
          title: 'Super Performance VPS Micro',
          price: '€5.99',
          specs: [
            '2 vCore (AMD Ryzen™ 9 7950X3D)',
            '2GB RAM',
            '20GB NVMe',
            'Uplink: 200 Mbps',
            'DDoS Protection',
            'High-Performance CPU'
          ]
        },
        {
          title: 'Super Performance VPS Lite',
          price: '€8.99',
          specs: [
            '2 vCore (AMD Ryzen™ 9 7950X3D)',
            '4GB RAM',
            '40GB NVMe',
            'Uplink: 200 Mbps',
            'DDoS Protection',
            'High-Performance CPU'
          ]
        },
        {
          title: 'Super Performance VPS Boost',
          price: '€12.99',
          specs: [
            '4 vCore (AMD Ryzen™ 9 7950X3D)',
            '6GB RAM',
            '60GB NVMe',
            'Uplink: 400 Mbps',
            'DDoS Protection',
            'High-Performance CPU'
          ]
        },
        {
          title: 'Super Performance VPS Turbo',
          price: '€15.99',
          specs: [
            '4 vCore (AMD Ryzen™ 9 7950X3D)',
            '8GB RAM',
            '80GB NVMe',
            'Uplink: 400 Mbps',
            'DDoS Protection',
            'High-Performance CPU'
          ]
        },
        {
          title: 'Super Performance VPS Power',
          price: '€20.99',
          specs: [
            '6 vCore (AMD Ryzen™ 9 7950X3D)',
            '12GB RAM',
            '100GB NVMe',
            'Uplink: 500 Mbps',
            'DDoS Protection',
            'High-Performance CPU'
          ]
        },
        {
          title: 'Super Performance VPS Pro',
          price: '€25.99',
          specs: [
            '6 vCore (AMD Ryzen™ 9 7950X3D)',
            '16GB RAM',
            '120GB NVMe',
            'Uplink: 600 Mbps',
            'DDoS Protection',
            'High-Performance CPU'
          ]
        },
        {
          title: 'Super Performance VPS Max',
          price: '€33.99',
          specs: [
            '8 vCore (AMD Ryzen™ 9 7950X3D)',
            '24GB RAM',
            '140GB NVMe',
            'Uplink: 800 Mbps',
            'DDoS Protection',
            'High-Performance CPU'
          ]
        },
        {
          title: 'Super Performance VPS Ultra',
          price: '€45.99',
          specs: [
            '8 vCore (AMD Ryzen™ 9 7950X3D)',
            '32GB RAM',
            '160GB NVMe',
            'Uplink: 1000 Mbps',
            'DDoS Protection',
            'High-Performance CPU'
          ]
        },
        {
          title: 'Super Performance VPS Hyper',
          price: '€65.99',
          specs: [
            '8 vCore (AMD Ryzen™ 9 7950X3D)',
            '48GB RAM',
            '180GB NVMe',
            'Uplink: 1000 Mbps',
            'DDoS Protection',
            'High-Performance CPU'
          ]
        }
      ]
    }
  }
};
